<template>
    <div class="car">
        <custom-plane title="车辆信息" :iconImg="require('@/assets/compImg/parking/carinfor.png')">
            <div class="car_data">
                <div class="car_title">车牌号</div>
                <div class="car_infor">
                    <div class="data">{{LicensePlate.slice(0,1)}}</div>
                    <div class="text">{{LicensePlate.slice(1)}}</div></div>
            </div>
        </custom-plane>
    </div>
</template>
<script>
export default {
    props:{
        LicensePlate:String
    }
}
</script>
<style lang="scss" scoped>
.car {
    width: 416px;
    height: 127px;
}
</style>